
export default function(o, onTimeChange){

  var start = function(e){

    console.log('start')

    move(e)

    $(document)
    .on('mousemove touchmove', move)

    $(document)
    .on('mouseup mouseleave touchend', end)

    e.stopPropagation()
    e.preventDefault()

  }

  var move = function(e){
    var x = e.originalEvent.pageX - div.offset().left
    var progress = x / (div.width() - 5)
    onTimeChange(progress)
    e.stopPropagation()
    e.preventDefault()
  }

  var end = function(){

    console.log('end')

    $(document)
    .off('mousemove touchmove mouseup mouseleave touchend')
  }

  var update =
    function(progress){
      var dw = div.width() - 10
      var cl = dw * progress
      cursor.css({left: `${cl}px`})
    }

  var cursor =
    $('<div>')
    .css({
      position: 'absolute',
      backgroundColor: o.colors.red,
      width: '0.35rem',
      height: '0.35rem',
      left: 0,
      top: 0,
      pointerEvents: 'none',
    })

  var div =$('<div>')
  .addClass('iphoneNavbarFixBottom')
  .append(
    $('<div>')
    .css({
      backgroundColor: o.colors.yellow,
      height: '0.35rem',
      userSelect: 'none',
    })
    .append(cursor)
    .on('mousedown touchstart', start)
  )

  div.update = update

  return div

}



// WEBPACK FOOTER //
// ./src/client/view/frontend/components/timeline/timeline.js